import initialState from './initialState';
 import {
 	FETCH_USER_PROFILE_INIT,
 	FETCH_USER_PROFILE_SUCCESS,
 	FETCH_USER_PROFILE_FAILURE, 	
	FETCH_USER_PROFILE_DISCONNECT_FITBIT_INIT,
	FETCH_USER_PROFILE_DISCONNECT_FITBIT_SUCCESS,
	FETCH_USER_PROFILE_DISCONNECT_FITBIT_FAILURE,
	FETCH_USER_PROFILE_RESET_TOURS_INIT,
	FETCH_USER_PROFILE_RESET_TOURS_SUCCESS,
	FETCH_USER_PROFILE_RESET_TOURS_FAILURE,
	RESET_USER_PROFILE
 } from '../../actions/user_profile/types';
import { saveLocalState, deleteLocalState } from '../../store/localStorage.js';
import Constants from '../../containers/function/constants.js';

 export default function userProfile(state = initialState, action) {
 	switch (action.type) {
 		case FETCH_USER_PROFILE_INIT:
 			return{
 				...state,
 				loading: true,
 				error: null
 			}; 		
		case FETCH_USER_PROFILE_SUCCESS:
 			return{
 				...state,
 				datos: action.payload.data,
 				error: null,
 				loading: false,
 				status: action.payload.status
 			};
		case FETCH_USER_PROFILE_FAILURE:
 			return{
 				...state,
 				datos: {},
 				error: action.payload,
 				loading: false,
 			};
  		case FETCH_USER_PROFILE_DISCONNECT_FITBIT_INIT:
 			return{
 				...state,
 				loading: true,
 				error: null
 			}; 		
		case FETCH_USER_PROFILE_DISCONNECT_FITBIT_SUCCESS:
 			return{
 				...state,
 				error: null,
 				loading: false,
 				status: action.payload.status
 			};
		case FETCH_USER_PROFILE_DISCONNECT_FITBIT_FAILURE:
 			return{
 				...state,
 				error: action.payload,
 				loading: false,
 			};
  		case FETCH_USER_PROFILE_RESET_TOURS_INIT:
 			return{
 				...state,
 				loading: true,
 				error: null
 			}; 		
		case FETCH_USER_PROFILE_RESET_TOURS_SUCCESS:
        	var viewedToursObject = {}
        
	        for(var tour in Constants.toursKeys) {
	          viewedToursObject[Constants.toursKeys[tour]] = false;
	        }
	        
	        saveLocalState({key:'viewedTours', value: JSON.stringify(viewedToursObject)});
	        
 			return{
 				...state,
 				error: null,
 				loading: false,
 				status: action.payload.status
 			};
		case FETCH_USER_PROFILE_RESET_TOURS_FAILURE:
 			return{
 				...state,
 				error: action.payload,
 				loading: false,
 			};
 		case RESET_USER_PROFILE:
	      	return{
	        	...state,
	        	datos: {},
			 	loading: true,
			 	error: null,
			 	status: null,
	      	};
 		default:
 			return state;
 	}
 }


// WEBPACK FOOTER //
// ./source/client/reducers/user_profile/index.js